import {React, useState, useRef, useEffect} from 'react';
import '../scss/dragAndDrop.scss'

export const DragDropFile = ({handleFileChange, docId, docKey, disabled = false}) => {
    // drag state
    const [dragActive, setDragActive] = useState(false);
    // ref
    const inputRef = useRef(null);

    const [file, setFile] = useState(null);
    
    // handle drag events
    const handleDrag = function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragActive(true);
      } else if (e.type === "dragleave") {
        setDragActive(false);
      }
    };
    
    // triggers when file is dropped
    const handleDrop = function(e) {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        // handleFile(e.dataTransfer.files);
        // handleFileChange(e, docId, docKey)
        setFile(e.dataTransfer.files)
      }
    };
    
    const handleFile = (files) => {
        alert("Number of files: " + files.length);
      }

    // triggers when file is selected with click
    const handleChange = function(e) {
      e.preventDefault();
      if (e.target.files && e.target.files[0]) {
        // handleFileChange(e, docId, docKey)
        setFile(e.target.files)
        // handleFile(e.target.files);
      }
    };
    
  // triggers the input when the button is clicked
    const onButtonClick = () => {
      inputRef.current.click();
    };
    
    return (
      <form id="form-file-upload" onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
        <input ref={inputRef} type="file" id={docId} className='d-none' multiple={false} onChange={handleFileChange}  />
        <label id="label-file-upload" htmlFor={docId} className={`${disabled ? 'disabled-div': ''}${dragActive ? "drag-active" : ""}` }>
        {file === null ? <div>
            {/* <p>Drag and drop your file here or</p> */}
            <div className="pointer" onClick={handleFileChange}>Upload a file</div>
          </div>  : <p> {file[0]?.name} </p>}          
        </label>
        { dragActive && <div id="drag-file-element disabled-div" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
      </form>
    );
  };